(function ($) {
    $(function () {

        /* HEADER */
        
        $('header .open-overlay-proposal').mouseover(function() {
            $('header').addClass('white-header');
            $('.toggle-menu').addClass('z-index');
        });
        $('header .open-overlay-proposal').mouseout(function() {
            $('header').removeClass('white-header');
            $('.toggle-menu').removeClass('z-index');
        });

        $('header .hamburger-menu').click(function() {
            $('header .overlay-menu').toggleClass('open');
            $('.toggle-menu').toggleClass('z-index');
        });

        // Check if header is sticky / not sticky on page open
        var y = $(this).scrollTop();
        if (y > 65) {
            $('header').addClass('sticky');
            $('.toggle-menu').addClass('sticky');
        }

        // Make header sticky / not sticky
        $(window).scroll(function() {
            var y = $(this).scrollTop();
            if (y > 65) {
                $('header').addClass('sticky');
                $('.toggle-menu').addClass('sticky');
            } else {
                $('header').removeClass('sticky');
                $('.toggle-menu').removeClass('sticky');
            }
        });

        $('header .menu-item-has-children').click(function() {
            $(this).toggleClass('open');
            var ul = $(this).parent('ul');
            var singleMenu = ul.parent().parent('.single-menu')
            singleMenu.toggleClass('no-border');
        });

        // HOMEPAGE ANIMATIONS
        $(window).scroll(function() {
            var windowH = $(window).height(),
              scrollY = $(window).scrollTop();
            $('.animate').each(function() {
              var elPosition = $(this).offset().top;
              if (scrollY > elPosition - windowH) {
                $(this).addClass("effect");
              }
            });
        });

    });

})(jQuery);


document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.frigerio-home-hero-block .banner-animated').forEach(function(element) {
        element.classList.add('entered');
    });
});